import { gql } from "@apollo/client";

import { adminStatusFragment } from "src/graphql/anti-fraud/fragments/AdminStatusFragment";
import { ruleFragment } from "src/graphql/anti-fraud/fragments/RuleFragment";
import { userFragment } from "src/graphql/anti-fraud/fragments/UserFragment";

export const scenarioVersionFragment = gql`
  fragment ScenarioVersionFragment on ScenarioVersion {
    id
    name
    description
    threshold
    activatedAt
    archivedAt
    adminStatus {
      ...AdminStatus
    }
    status
    scenario {
      id
      name
      caseType {
        code
      }
    }
  }

  ${adminStatusFragment}
`;

export const scenarioVersionWithRulesFragment = gql`
  fragment ScenarioVersionWithRulesFragment on ScenarioVersion {
    ...ScenarioVersionFragment
    rules {
      rule {
        ...RuleFragment
      }
      score
      createdAt
      createdBy {
        ...UserFragment
      }
    }
  }

  ${ruleFragment}
  ${userFragment}
  ${scenarioVersionFragment}
`;
